function LocationLoader() {
  return (
    <div data-testid="location-loader" className="animate-pulse">
      <div className="mb-6">
        <div className="mb-1">
          <div className="inline-block h-8 w-36 rounded bg-slate-300"></div>
          <div className="ml-2 inline-block h-6 w-48 rounded bg-slate-300"></div>
        </div>
        <div className="h-3 w-48 rounded bg-slate-300"></div>
      </div>
    </div>
  );
}

export default LocationLoader;
